import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Modal, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteReferralData } from "../types/discounts";
import { deleteReferralPlan } from "../apis/referralPlans";

const closeIconStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "end",
  marginBottom: 1,
};

const ReferralDeleteModal = (props: DeleteReferralData) => {
  const { deleteId, setOpenState, openState, dataset, setData, fetchUpdatedData } = props;

  const handleReferralDeleteClose = () => setOpenState(false);

  const deleteRecord = async () => {
    const res = await deleteReferralPlan(deleteId);
    if (res?.status) {
      fetchUpdatedData();
      handleReferralDeleteClose();
    }
  };

  return (
    <>
      <Modal
        open={openState}
        onClose={handleReferralDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
          }}
        >
          <Box>
            <Box sx={closeIconStyle}>
              <CloseIcon sx={{ cursor: "pointer" }} onClick={handleReferralDeleteClose} />
            </Box>
            <Box style={{ marginBottom: "30px" }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Delete Referral
              </Typography>
            </Box>
          </Box>
          <Box
            style={{
              paddingBottom: "20px",
            }}
          >
            Do you want delete this referral?
          </Box>

          <Box sx={closeIconStyle}>
            <Button variant="contained" onClick={deleteRecord}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ReferralDeleteModal;
